/* eslint-disable @typescript-eslint/no-explicit-any */
import { MAINNET_USDC_TOKEN_ADDRESS, TESTNET_USDC_TOKEN_ADDRESS } from '@constants/contracts'
import { useMint, usePaymasterMintNFT, useUserHasLowBalance } from '@hooks'

export enum MintType {
  Usdc = 'USDC',
  Eth = 'ETH'
}

interface ReturnType {
  mint: () => Promise<{ to: string; transactionHash: `0x${string}` }>
  errorMessage: string | null | undefined
  isContractReady: boolean
  isLoading: boolean
}

interface Props {
  mintType?: MintType | null
  functionName: string
  args: any[]
  contract: `0x${string}`
  abi: any
  isMainnet: boolean
}

const useMintTypeBased = ({ mintType, functionName, args, contract, abi, isMainnet }: Props): ReturnType => {
  useUserHasLowBalance({
    contract: isMainnet ? MAINNET_USDC_TOKEN_ADDRESS : TESTNET_USDC_TOKEN_ADDRESS,
    enabled: mintType === MintType.Usdc
  })

  const config = {
    functionName,
    args: [...args],
    contract,
    abi,
    isMainnet
  }

  const UsdcData = usePaymasterMintNFT(config)
  const EthData = useMint(config)

  return mintType === MintType.Usdc ? UsdcData : EthData
}

export default useMintTypeBased
